<template>
    <div class="modal modal-full padding-wrapper transform payment-modal"></div>
</template>

<script>
export default {
    name: 'payment.pending.redirect',
}
</script>
